export const GoogleMapsAPI = 'AIzaSyAivMerpNo6pvw2HXu5lrtCJcg7m8Z81pc';
